export default "__VITE_ASSET__DhjcieDo__"